import { styled } from 'goober';
import { appColors } from './useTheme';
export var Avatar = styled('span')(function (_a) {
    var _b = _a.$size, $size = _b === void 0 ? '30px' : _b;
    return ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: $size,
        height: $size,
        backgroundColor: '#F2F4F9',
        borderRadius: '100px',
        marginRight: '8px',
    });
});
export var ListItem = styled('div')(function (_a) {
    var _b = _a.$isSelected, $isSelected = _b === void 0 ? false : _b;
    return ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '6px',
        paddingTop: '20px',
        paddingBottom: '20px',
        paddingRight: '0px',
        paddingLeft: '10px',
        width: '264px',
        height: '32px',
        cursor: 'pointer',
        backgroundColor: $isSelected ? appColors.primary.w50 : appColors.ui.white,
    });
});
export var MenuOption = styled('div')(function (_a) {
    var _b = _a.$isSelected, $isSelected = _b === void 0 ? false : _b;
    return ({
        borderRadius: '5px',
        paddingLeft: '15px',
        paddingRight: '15px',
        paddingTop: '10px',
        paddingBottom: '10px',
        cursor: 'pointer',
        color: $isSelected ? appColors.ui.white : 'black',
        backgroundColor: $isSelected ? appColors.primary.w500 : appColors.neutral.w50,
    });
});
export var UserFullName = styled('p')(function (_a) {
    var _b = _a.$color, $color = _b === void 0 ? 'black' : _b;
    return ({
        display: 'inline-block',
        fontSize: '12',
        textAlign: 'center',
        color: $color,
        margin: '0',
    });
});
export var TESearchBar = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%',
        padding: '0px 10px 10px 10px',
        gap: '5px',
        alignItems: 'center',
    });
});
